module.exports = __webpack_public_path__ + "media/images/categories/icon_cat27-d1206f468fe70b6117bb9320fd8ea3c9.svg";